import { render, staticRenderFns } from "./NewDetails.vue?vue&type=template&id=1c3e604e&scoped=true&"
import script from "./NewDetails.vue?vue&type=script&lang=js&"
export * from "./NewDetails.vue?vue&type=script&lang=js&"
import style0 from "./NewDetails.vue?vue&type=style&index=0&id=1c3e604e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3e604e",
  null
  
)

export default component.exports